import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import avtar from "../../assets/images/Profile-Picture.jpg";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AvatarPic from '../../assets/images/avtarPic.png';
import SendIcon from '@mui/icons-material/Send';

function MobileChatScreen() {
    const navigate = useNavigate();
  return (
    <div className='mainwrapperView'>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileChatList")}
        />
        <h1>Chat Screen</h1>
      </div>
      <div className="famDetailsListInrMob">
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
            <img src={avtar} className="useImage" alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>User Name</h1>
              <div className="mobWithIco">
                <LocalPhoneIcon />
                <p>9881789836</p>
              </div>
            </div>
          </div>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
        <div className='pollsTitlDescView'>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Product Name :</p>
            <p className='ListNameTxt'>ABCD ABCD</p>
        </div>
        <div className='ListingTitleName margin0'>
            <p className='ListTitleTxt'>Price :</p>
            <p className='ListNameTxt'><CurrencyRupeeIcon sx={{fontSize:16}}/> 123.00</p>
        </div>
        </div>
        </div>
      </div>
    <div className='ListingView'>
    <div className='ChatView1'>
        <div className="famDetailsListTo">
          <div className="alignfamDetailsListToPro">
            <div className="ImageViewRound">
              <img src={AvatarPic} alt='altimg'/>
            </div>
            <div className="detailsDiMob">
              <h1>Fname Lname</h1>
              <div className="mobWithIco">
                <p>11/12/2024</p>
              </div>
            </div>
          </div>
        </div>
        <div className='dividerCommon' />
        <p className='descriptionComplainDetails'>
            Description Description Description Description Description Description
        </p>
    </div>
    <div className='ChatView2'>
    <div className="famDetailsListTo textAlignEnd">
        <div className="alignfamDetailsListToPro ">
        <div className="detailsDiMob textAlignEnd">
            <h1>Fname Lname</h1>
            <div className="mobWithIco">
            <p>11/12/2024</p>
            </div>
        </div>
        <div className="ImageViewRound">
            <img src={AvatarPic} alt='altimg'/>
        </div>
        </div>
        </div>
    <div className='dividerCommon' />
    <p className='descriptionComplainDetails'>
        Description Description Description Description Description Description
    </p>
    </div>
    </div>
    <div className='chatInputBoxView'>
        <input type='text' placeholder='Enter Message Here' className='chatInputBox'/>
        <SendIcon sx={{fontSize:35, color:'#005aff'}} />
    </div>
    </div>
  )
}

export default MobileChatScreen